import React from 'react'
import { CheckBox } from '@st-operations/uikit/src/v2'

import { useEventFeedsContext } from '../../../context/index.jsx'

const HemProviderForm = ({}) => {
  const {
    data: { deliveries },
    dispatch,
    ACTIONS,
  } = useEventFeedsContext()
  const delivery = deliveries[0] ?? {}

  const onChange = (value) => {
    // clone the hem providers so we update immutably
    // if hem providers doesn't exist default to an empty array
    let hemProviders = [...(delivery.hemProviders || [])]

    if (hemProviders.includes(value)) {
      let index = hemProviders.indexOf(value)
      hemProviders.splice(index, 1)
    } else {
      hemProviders.push(value)
    }

    dispatch({
      type: ACTIONS.UPDATE_DELIVERY,
      payload: {
        hemProviders,
      },
    })
  }

  return (
    <>
      <CheckBox
        checked={delivery.hemProviders?.includes('liveintent')}
        onChange={() => onChange('liveintent')}
      />
      <span className="delivery-content__content-checkbox">LiveIntent</span>
      <CheckBox
        checked={delivery.hemProviders?.includes('sovrn')}
        onChange={() => onChange('sovrn')}
      />
      <span className="delivery-content__content-checkbox">Sovrn</span>
      <CheckBox
        checked={delivery.hemProviders?.includes('yobi')}
        onChange={() => onChange('yobi')}
      />
      <span className="delivery-content__content-checkbox">Yobi</span>
      <CheckBox
        checked={delivery.hemProviders?.includes('tapad')}
        onChange={() => onChange('tapad')}
      />
      <span className="delivery-content__content-checkbox">Tapad</span>
    </>
  )
}

export default HemProviderForm
